module.exports = __webpack_public_path__ + "static/media/bulk_upload_month_sob.015f0353.csv";